import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const navbarContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    hideBadge: z.boolean(),
    showFreeCaseReviewButton: z.boolean(),
    showTalkToSpecialistButton: z.boolean(),
    ctaAction: z.enum(['scroll_to_form', 'link_to_page']),
    navLinks: z.array(
      z.object({
        label: z.string().min(1),
        href: z.string().optional(),
        isClaimSections: z.boolean().optional(),
        isLocations: z.boolean().optional(),
      })
    ),
  }),
});

export const contentTypeNavbarContentSchema = contentBase.extend({
  content: navbarContentSchema,
  is_default: z.boolean().optional(),
  claim_section_id: z.number().int().positive().nullish(),
});

export type ContentTypeNavbarContentInput = z.infer<typeof contentTypeNavbarContentSchema>;
